import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Notifications from "@/pages/Notifications.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Typography from "@/pages/Typography.vue";
import TableList from "@/pages/TableList.vue";
import Transactions from "@/pages/Transactions.vue";
import Login from "@/pages/Login.vue";
import Register from "@/pages/Register.vue";
import AddTerminal from "@/pages/AddTerminal.vue";
import WalletReports from "@/pages/WalletReports.vue";
import AddMerchant from "@/pages/AddMerchant.vue";
import Merchants from "@/pages/Merchant.vue";
import Terminals from "@/pages/Terminals.vue";
import EditMerchant from "@/pages/EditMerchant.vue";
import MerchantAgents from "@/pages/Agents.vue";
import CreateAgent from "@/pages/AddAgent.vue";
import ViewAgent from "@/pages/ViewAgent";
import Terminal from "@/pages/Terminal";
import UploadTerminal from "@/pages/UploadTerminal";
import AddInstitution from "@/pages/AddInstitution.vue";
import Institutions from "@/pages/Institutions.vue";
import EditInstitution from "@/pages/EditInstitution.vue";
import TerminalConfig from "@/pages/TerminalConfig";
import RemoteDownload from "@/pages/RemoteDownload.vue";
import Charges from "@/pages/Charges.vue";
import CreateCharge from "@/pages/CreateCharge.vue";
import UpdateCharge from "@/pages/UpdateCharge.vue";
import ViewUsers from "@/pages/ViewUsers.vue";
import ViewUser from "@/pages/ViewUser.vue";
import ChangePassword from "@/pages/ChangePassword.vue";
import Logs from "@/pages/Logs.vue";
import Funding from "@/pages/Funding";
import VasTransactions from "@/pages/VasTransactions.vue";
import PayWithTransfer from "@/pages/PayWithTransfer.vue";
import InstitutionCharges from "@/pages/InstitutionCharges.vue";
import CreateInstitutionCharge from "@/pages/CreateInstitutionCharge.vue";
import UpdateInstitutionCharge from "@/pages/UpdateInstitutionCharge.vue";
import Profile from "@/pages/Profile.vue";
import Providers from "@/pages/Providers.vue";
import SingleMerchantAgents from "@/pages/MerchantAgents.vue";
import OthersFunding from "@/pages/OthersFunding";
import FundRequests from "@/pages/FundRequests";
import FundRequest from "@/pages/FundRequest";
import RequestFunds from "@/pages/RequestFunds";
import RequestFundList from "@/pages/RequestFundList";
import WalletFunding from "@/pages/WalletFunding";
import createFunding from "@/pages/InitiateFunding";
import ActivityLogs from "@/pages/ActivityLogs";
import AllAgents from "@/pages/AllAgents";
import AgentVirtualAccounts from "@/pages/AgentVirtualAccounts";
import RoleManagement from "@/pages/RoleManagement";
import AddRole from "@/pages/AddRole";
import ViewRole from "@/pages/ViewRole";
import Routing from "@/pages/Routing";
import AddRoute from "@/pages/AddRoute";
import UpdateRouting from "@/pages/UpdateRouting";
import LoginOtp from "@/pages/loginOtp";
import TmsUserAgents from "@/pages/TmsUserAgents";
import UpdateAccount from "@/pages/RegularizeAccount";
import BusinessAccount from "@/pages/BusinessAccount";
import IndividualAccount from "@/pages/IndividualAccount";
import ViewAgentkyc from "@/pages/ViewAgentkyc";
import ViewBusinessKyc from "@/pages/ViewBusinessKyc";
import AddAgentView from "@/pages/AddAgentView";
import AddBusinessView from "@/pages/AddAgentBusinessView";
import TransactionLimits from "../pages/TransactionLimits.vue";
import AllAccountsKyc from "../pages/AllAccountsKyc.vue";
import ViewMerchantAgent from "../pages/ViewMerchantAgent.vue";
import ViewMerchantBusiness from "../pages/ViewMerchantBusiness.vue";

import AddAccount from "@/pages/AddAccount.vue";
import ViewBusinessAccount from "@/pages/ViewBusinessAccount.vue";
import Purchases from "@/pages/Purchases.vue";
import MerchantAgent from "@/pages/MerchantAgent.vue";
import Accounts from "@/pages/Accounts.vue";
import AnalyticsTerminals from "@/pages/AnalyticsTerminals.vue";
import AnalyticsTransactions from "../pages/AnalyticsTransactions.vue";

import PtspTerminals from "@/pages/PtspTerminals.vue";
import PtspTerminal from "@/pages/PtspTerminal.vue";
import AddPtspTerminal from "@/pages/AddPtspTerminal.vue";
import MerchantTerminals from "@/pages/MerchantTerminals.vue";
import TerminalVirtualAccounts from "@/pages/TerminalVirtualAccounts.vue";
import PtspTerminalConfig from "../pages/PtspTerminalConfig.vue";
import UploadPtspTerminal from "../pages/UploadPtspTerminal.vue";
import PtspMerchants from "../pages/PtspMerchants.vue";
import PtspPayWithTransfer from "../pages/PtspPayWithTransfer.vue";
import AddPtspMerchant from "../pages/AddPtspMerchant.vue";
import EditPtspMerchant from "../pages/EditPtspMerchant.vue";

const routes = [
  {
    path: "/",
    name: "landing",
    redirect: "/login",
    component: Login,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/login/otp/:email",
    name: "loginOtp",
    component: LoginOtp,
  },
  {
    path: "/dashboard",
    component: DashboardLayout,
    children: [
      {
        path: "/",
        name: "dashboard",
        component: Dashboard,
      },
      {
        path: "stats",
        name: "stats",
        component: UserProfile,
      },
      {
        path: "routing",
        name: "Routing",
        component: Routing,
      },
      {
        path: "routing/:routeId",
        name: "Update Routing",
        component: UpdateRouting,
      },
      {
        path: "add-route",
        name: "Add Route",
        component: AddRoute,
      },
      {
        path: "add-terminal",
        name: "Add Terminal",
        component: AddTerminal,
      },
      {
        path: "upload-terminal",
        name: "Upload TIDs & Terminals",
        component: UploadTerminal,
      },
      {
        path: "upload-ptspterminal",
        name: "Upload TIDs & Terminals",
        component: UploadPtspTerminal,
      },
      {
        path: "wallet-funding",
        name: "Wallet Funding",
        component: WalletFunding,
      },
      {
        path: "wallet-funding",
        name: "Debit or Credit Agent Wallet",
        component: OthersFunding,
      },
      {
        path: "funding/wallet-funding",
        name: "Debit or Credit Wallet",
        component: Funding,
      },
      {
        path: "initiate-funding",
        name: "Debit or Credit Merchant Wallet",
        component: createFunding,
      },
      {
        path: "merchant/agents",
        name: "Merchant Agents",
        component: SingleMerchantAgents,
      },
      {
        path: "transaction-limits",
        name: "Transaction Limits",
        component: TransactionLimits,
      },
      {
        path: "transactions",
        name: "transactions",
        component: Transactions,
      },
      {
        path: "purchases",
        name: "Purchases",
        component: Purchases,
      },
      {
        path: "wallet-reports",
        name: "wallet-reports",
        component: WalletReports,
      },
      {
        path: "notifications",
        name: "notifications",
        component: Notifications,
      },
      {
        path: "providers",
        name: "Providers",
        component: Providers,
      },
      {
        path: "vas-transactions",
        name: "Vas Transactions",
        component: VasTransactions,
      },
      {
        path: "pay-with-transfer",
        name: "Pay With Transfer",
        component: PayWithTransfer,
      },
      {
        path: "ptsp-pay-with-transfer",
        name: "Pay With Transfer",
        component: PtspPayWithTransfer,
      },
      {
        path: "charges",
        name: "Charges",
        component: Charges,
      },
      {
        path: "create-charge",
        name: "Create Transaction Charge",
        component: CreateCharge,
      },
      {
        path: "institution-charges",
        name: "Institution Charges",
        component: InstitutionCharges,
      },
      {
        path: "create-institution-charge",
        name: "Create Institution Charge",
        component: CreateInstitutionCharge,
      },
      {
        path: "wallet-funding",
        name: "Debit or Credit Wallet",
        component: Funding,
      },
      // {
      //   path: "fund-request-list",
      //   name: "Funding Requests List",
      //   component: FundRequests,
      // },
      {
        path: "fund-request/:requestId",
        name: "Funding Request",
        component: FundRequest,
      },
      {
        path: "merchant/request-funds",
        name: "Funding Request",
        component: RequestFunds,
      },
      {
        path: "merchant/my-request-funds",
        name: "Funding Request List",
        component: RequestFundList,
      },
      {
        path: "charge/:chargeId",
        name: "Charge",
        component: UpdateCharge,
      },
      {
        path: "institution-charge/:chargeId",
        name: "Institution Charge",
        component: UpdateInstitutionCharge,
      },
      {
        path: "create-user",
        name: "Create Admin",
        component: Register,
      },
      {
        path: "view-users",
        name: "View Administrators",
        component: ViewUsers,
      },
      {
        path: "user/:userId",
        name: "View Admin",
        component: ViewUser,
      },
      {
        path: "change-password",
        name: "Change Password",
        component: ChangePassword,
      },
      {
        path: "create-category",
        name: "Create Category",
        component: AddMerchant,
      },
      {
        path: "create-ptsp-merchant",
        name: "Create Merchant",
        component: AddPtspMerchant,
      },
      {
        path: "merchants",
        name: "Agent Category",
        component: Merchants,
      },
      {
        path: "ptsp-merchants",
        name: "Merchants",
        component: PtspMerchants,
      },
      {
        path: "category/:id",
        name: "Edit Agent Category",
        component: EditMerchant,
      },
      {
        path: "ptsp-merchant/:id",
        name: "Edit Merchant",
        component: EditPtspMerchant,
      },
      {
        path: "create-institution",
        name: "Create Institution",
        component: AddInstitution,
      },
      {
        path: "institutions",
        name: "institutions",
        component: Institutions,
      },
      {
        path: "institution/:id",
        name: "Edit Institution",
        component: EditInstitution,
      },
      {
        path: "agent/:agentId",
        name: "View Agent",
        component: ViewAgent,
      },
      {
        path: "merchant/agent/:agentId",
        name: "View Merchant Agent",
        component: ViewMerchantAgent,
      },
      {
        path: "merchant/business-account-agent/:agentId",
        name: "View Merchant Agent Business Account",
        component: ViewMerchantBusiness,
      },
      {
        path: "all-agents",
        name: "All Agents",
        component: AllAgents,
      },
      {
        path: "merchant-agents",
        name: "Merchant Agents",
        component: MerchantAgent,
      },
      {
        path: "business-account-agent/:agentId",
        name: "View Agent Details",
        component: ViewBusinessAccount,
      },
      {
        path: "add-account",
        name: "Add Agent",
        component: AddAccount,
      },
      {
        path: "virtual-accounts/:agentId",
        name: "Agents Virtual Accounts",
        component: AgentVirtualAccounts,
      },
      {
        path: "admin/profile",
        name: "Profile Actions",
        component: Profile,
      },
      {
        path: "merchant/:merchantId/agents",
        name: "Agents",
        component: MerchantAgents,
      },
      {
        path: "merchant/:merchantId/create-agent",
        name: "Merchant Agents",
        component: CreateAgent,
      },
      {
        path: "merchant-agents",
        name: " Merchant Agents",
        component: TmsUserAgents,
      },
      {
        path: "terminals",
        name: "Terminals",
        component: Terminals,
      },
      {
        path: "get-logs",
        name: "Transaction Logs",
        component: Logs,
      },
      {
        path: "terminal-remote-download",
        name: "Remote Download",
        component: RemoteDownload,
      },
      {
        path: "view-terminal/:terminalId",
        name: "Terminal Management",
        component: Terminal,
        props: true,
      },
      {
        path: "terminal-configuration",
        name: "Terminal Configuration",
        component: TerminalConfig,
      },
      {
        path: "activity-logs",
        name: "Activity Logs",
        component: ActivityLogs,
      },
      {
        path: "update-accounts",
        name: "Update Account",
        component: UpdateAccount,
      },
      {
        path: "agent-All-Account",
        name: "All Accounts",
        component: AllAccountsKyc,
      },
      {
        path: "agent-business-account",
        name: "Business Account",
        component: BusinessAccount,
      },
      {
        path: "agent-Individual-Account",
        name: "Individual Account",
        component: IndividualAccount,
      },
      {
        path: "agent-kyc/:agentId",
        name: "View Agent kyc",
        component: ViewAgentkyc,
      },
      {
        path: "business-agent-kyc/:agentId",
        name: "View kyc details",
        component: ViewBusinessKyc,
      },
      {
        path: "add-agent-account",
        name: "Add Agent",
        component: AddAgentView,
      },
      {
        path: "role-management",
        name: "Role Management",
        component: RoleManagement,
        props: true,
      },
      {
        path: "add-role",
        name: "Add Role",
        component: AddRole,
      },
      {
        path: "view-role/:id",
        name: "View Role",
        component: ViewRole,
      },
      {
        path: "accounts",
        name: "Accounts",
        component: Accounts,
      },
      {
        path: "analytics-terminals",
        name: "Analytics Terminals",
        component: AnalyticsTerminals,
      },
      {
        path: "analytics-transactions",
        name: "Analytics Transactions",
        component: AnalyticsTransactions,
      },
      {
        path: "ptsp-terminals",
        name: "Terminals",
        component: PtspTerminals,
      },
      {
        path: "view-ptspterminal/:terminalId",
        name: "View Terminal",
        component: PtspTerminal,
      },
      {
        path: "add-ptsp-terminal",
        name: "Add Terminal",
        component: AddPtspTerminal,
      },
      {
        path: "merchant/:merchantId/terminals",
        name: "Merchant Terminals",
        component: MerchantTerminals,
      },
      {
        path: "/terminal/virtual-accounts/:terminalId",
        name: "Virtual Accounts",
        component: TerminalVirtualAccounts,
      },
      {
        path: "ptspterminal-configuration",
        name: "Terminal Configuration",
        component: PtspTerminalConfig,
      },
      {
        path: "icons",
        name: "icons",
        component: Icons,
      },
      {
        path: "maps",
        name: "maps",
        component: Maps,
      },
      {
        path: "typography",
        name: "typography",
        component: Typography,
      },
      {
        path: "table-list",
        name: "table-list",
        component: TableList,
      },
    ],
  },
  { path: "*", component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
